'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (_ref) {
    var layout = _ref.layout,
        i18n = _ref.i18n;


    var nameTextField = Ext.create('Ext.form.field.Text', {
        width: _FavoriteStyle2.default.windowCmpWidth,
        height: 45,
        style: 'margin-top: 2px; margin-bottom: 0',
        fieldStyle: _FavoriteStyle2.default.textfieldStyle.join(';'),
        fieldLabel: i18n.name,
        labelAlign: 'top',
        labelStyle: _FavoriteStyle2.default.textFieldLabelStyle.join(';'),
        labelSeparator: '',
        emptyText: 'Unnamed',
        enableKeyEvents: true,
        currentValue: '',
        value: layout.name,
        setEventChangeHandler: function setEventChangeHandler(handler) {
            this.eventChangeHandler = handler;
        },
        setEventKeyUpHandler: function setEventKeyUpHandler(handler) {
            this.eventKeyUpHandler = handler;
        },
        listeners: {
            change: function change(cmp, e) {
                if (this.eventChangeHandler) {
                    this.eventChangeHandler(cmp, e);
                }
            },
            keyup: function keyup(cmp, e) {
                if (e.keyCode === 13 && this.eventKeyUpHandler) {
                    this.eventKeyUpHandler(cmp, e);
                }
            }
        }
    });

    var descriptionTextField = Ext.create('Ext.form.field.TextArea', {
        width: _FavoriteStyle2.default.windowCmpWidth,
        rows: 3,
        style: 'margin-bottom: 0',
        fieldStyle: _FavoriteStyle2.default.textfieldStyle.concat(['padding-top: 5px']).join(';'),
        fieldLabel: i18n.description,
        labelAlign: 'top',
        labelStyle: _FavoriteStyle2.default.textFieldLabelStyle.join(';'),
        labelSeparator: '',
        emptyText: 'No description (optional)',
        enableKeyEvents: true,
        value: layout.description
    });

    var titleTextField = Ext.create('Ext.form.field.Text', {
        width: _FavoriteStyle2.default.windowCmpWidth,
        height: 45,
        style: 'margin-bottom: 0',
        fieldStyle: _FavoriteStyle2.default.textfieldStyle.join(';'),
        fieldLabel: i18n.title,
        labelAlign: 'top',
        labelStyle: _FavoriteStyle2.default.textFieldLabelStyle.join(';'),
        labelSeparator: '',
        emptyText: 'No title (optional)',
        enableKeyEvents: true,
        currentValue: '',
        value: layout.title,
        setEventKeyUpHandler: function setEventKeyUpHandler(handler) {
            this.eventKeyUpHandler = handler;
        },
        listeners: {
            keyup: function keyup(cmp, e) {
                if (e.keyCode === 13 && this.eventKeyUpHandler) {
                    this.eventKeyUpHandler(cmp, e);
                }
            }
        }
    });

    return {
        nameTextField: nameTextField,
        descriptionTextField: descriptionTextField,
        titleTextField: titleTextField
    };
};

var _FavoriteStyle = require('./FavoriteStyle');

var _FavoriteStyle2 = _interopRequireDefault(_FavoriteStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=FavoriteTextCmp.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/ui/FavoriteTextCmp.js
 ** module id = 36
 ** module chunks = 0 1
 **/